import type { QueryClient } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';

import { ExpiredLinkScreen, MobileLayout } from '../components';
import { externalAuthLoader } from '../data-access';
import { CheckoutFormOnDevice } from '../pages/CheckoutFormOnDevice/CheckoutFormOnDevice';
import { LinkBankOnDevice } from '../pages/LinkBankOnDevice/LinkBankOnDevice';
import { LoginOnDevice } from '../pages/LoginOnDevice/LoginOnDevice';
import { orderCompleteRoute } from './orderCompleteRoutes';

export const mobileDeviceRoutes = (queryClient: QueryClient): RouteObject => ({
  children: [
    {
      element: <CheckoutFormOnDevice />,
      path: 'cart/:cartUuid',
    },
    {
      element: <LoginOnDevice />,
      path: `login`,
    },
    // Exchange only: the loader redirects to `login` or `link-expired`, or throws.
    {
      loader: externalAuthLoader(queryClient),
      path: `external-auth`,
    },
    {
      element: <ExpiredLinkScreen />,
      path: `link-expired`,
    },
    {
      element: <LinkBankOnDevice />,
      path: `link-bank`,
    },
    orderCompleteRoute(true),
  ],
  element: <MobileLayout />,
  path: 'mobile',
});
